module.exports = __webpack_public_path__ + "static/media/locked.3472768c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/locked.svg
// module id = 869
// module chunks = 0